import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';

//Material Components
import { Grid, Checkbox, Button } from '@material-ui/core';
import { CheckBox, CheckBoxOutlineBlank } from '@material-ui/icons';

// Engage Actions 
import { GetHomeApps, UpdateHomeAppByCommunity } from '../../actions/homeAppsActions';
import { getResidentsByCommunity } from '../../actions/residentActions'

//Engage Components
import {
    LegacyRenderSelectV2
} from '../../utils/engageComponents';

export class ManagementTile extends Component {

    constructor(props) {
        super(props);

        this.state = {
            community: props.communityInfo,
            residentSelected: { _id: '000', name: 'All residents' },
            selectedTiles: 0,
            initialAppsStatus: undefined,
            appsStatus: undefined
        };

        if (props.communityInfo) {
            this.props.getResidentsByCommunity(props.communityInfo._id);
            this.props.GetHomeApps(props.communityInfo.communityId);
        }
    }

    componentWillReceiveProps(nextProps) {
        let communityId = this.state.community ? this.state.community._id : undefined
        if (communityId === undefined || communityId !== nextProps.communityInfo._id) {
            this.setState(
                {
                    community: nextProps.communityInfo
                }
            );
            if (nextProps.communityInfo) {
                this.setState({ residentSelected: { _id: '000', name: 'All residents' } }, () => {
                    this.props.getResidentsByCommunity(nextProps.communityInfo._id);
                    this.props.GetHomeApps(nextProps.communityInfo.communityId);
                });
            }
        }
    }

    async onSubmitHandler(formData) {
        const newArrayHomeApps = this.GetHomeAppsUpdateArray();

        if (newArrayHomeApps && localStorage.getItem('communityId')) {
            let residentid = this.state?.residentSelected?._id;
            residentid = residentid !== '000' ? residentid : undefined;

            const stylesObj = { modalStyles: { backgroundColor: '#ffffff' }, messageClass: 'LAlertMessageStyles' };
            this.props.UpdateHomeAppByCommunity(newArrayHomeApps, localStorage.getItem('communityId'), residentid, localStorage.getItem('username'), stylesObj);
        }
    };

    GetHomeAppsUpdateArray = () => {
        let newAppsArray = [];

        if (this.state.appsStatus) {
            newAppsArray = this.state.appsStatus.map(homeApp => {
                return {
                    "_id": homeApp._id,
                    "active": homeApp.active
                }
            });
        }

        return newAppsArray;
    };

    handlerSetResidentSelected = (residentSelected) => {
        if (residentSelected) {
            this.setState({ residentSelected: residentSelected });
            //this.props.dispatch(change('CommunitySettingsForm', 'SelectResident', residentSelected));

            const communitytid = this.state.community?.communityId;
            const residentid = residentSelected._id;

            this.props.GetHomeApps(communitytid, (residentid !== '000') ? residentid : undefined);
        }
    };

    setInitialState = () => {

        //Get Initial resident selected (first element) if not exist
        let intialResidentSelected = this.state?.residentSelected;

        if (!intialResidentSelected && this.props.residentData && this.props.residentData.length > 0) {
            intialResidentSelected = this.props.residentData[0];
        };

        let initialAppsStatus = [];

        initialAppsStatus = this.props.homeAppsData.map(app => {
            const active = (app.tileAvailable) ? app.tileAvailable : false;
            const iconUrl = app.iconUrl ? app.iconUrl : undefined;

            return {
                '_id': app._id,
                'appName': app.name,
                'active': active,
                'iconUrl': iconUrl,
                'order': app.order
            }
        });

        //Get state of the siwtch for select all
        const allCommunitiesSelected = !initialAppsStatus.some(el => el.active === false);

        //Create 2 separeta arrays for the Apps Status (No reference)
        const initialStatus = initialAppsStatus.map(x => Object.assign({}, x));
        const currentStatus = initialAppsStatus.map(x => Object.assign({}, x));

        //Set state
        this.setState(
            {
                startHomeApps: this.props.homeAppsData,
                initialAppsStatus: initialStatus,
                appsStatus: currentStatus,
                switchAllCommunitiesSelected: allCommunitiesSelected,
                residentSelected: intialResidentSelected
            })
    }


    handleCheckBoxClick = (appObject) => {
        let currentData = this.state.appsStatus ? this.state.appsStatus : [];

        currentData = currentData.map(item => {
            if (item._id === appObject._id)
                item.active = !item.active;

            return item;
        });

        this.setState({ appsStatus: currentData });
    };

    handleSelectAll = () => {
        let currentData = this.state.appsStatus ? this.state.appsStatus : [];
        const total = currentData.filter(item => item.active).length > 0 ? currentData.filter(item => item.active).length : 0;
        let selectAll = total === currentData.length ? false : true;

        currentData = currentData.map(item => {
            item.active = selectAll;
            return item;
        });

        this.setState({ appsStatus: currentData });
    }

    render() {

        const currentData = this.state.appsStatus ? this.state.appsStatus : [];
        const total = currentData.filter(item => item.active).length > 0 ? currentData.filter(item => item.active).length : 0;

        if (this.state.community) {
            if (this.props.homeAppsData && this.props.residentData) {
                if ((!this.state.appsStatus) || (this.state.startHomeApps !== this.props.homeAppsData)) {
                    this.setInitialState();
                }
            }
        }

        return (
            <>
                <div id="save_tiles_btn" className="appbtn-engage skybluebtn-engage" style={{ display: 'none' }} onClick={this.props.handleSubmit(this.onSubmitHandler.bind(this))}>
                    Save
                </div>
                <Grid container justify='space-around'  >
                    <Grid item xs={12} sm={12} md={3} lg={3} >
                        <Grid container direction='column' style={{ padding: '10px 20px' }}>
                            <Grid item xs={12} >
                                <Grid container direction='colum'>
                                    <Grid item xs={12} style={{ marginTop: '30px' }}>
                                        <Grid item container xs={12} justify='center' className='LselectResidentMessage'>
                                            Select or search for a resident or choose All Residents to customize the entire community.
                                        </Grid>
                                    </Grid>
                                    <Grid item xs={12} className='LCommunityName'>
                                        <Field
                                            showStartAdornment={true}
                                            name="SelectResident"
                                            disabled={false}
                                            maxLength={20}
                                            selected={this.state.residentSelected}
                                            optionsItemsIconsData={this.props.residentData ? this.props.residentData : []}
                                            onChangeHandler={(e, newItem) => this.handlerSetResidentSelected(newItem)}
                                            component={LegacyRenderSelectV2}
                                            diableClear={true}
                                            idToSet="legacy_Settings_renderSelect"
                                            id='legacy_Settings_renderSelect'
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>

                        </Grid>
                    </Grid>
                    { /*    TILES LIST   */}
                    <Grid item xs={12} sm={12} md={9} lg={9} className='LborderLine' style={{ padding: '0px 20px' }}>
                        <Grid container className="activityTitle-engage">
                            {/* Selected All Button and selected item counter */}
                            <Grid item container xs={4} justifyContent='flex-start' alignItems='center'>
                                <Button id='addEditDevice_Headers_SelectAll' className="LselectAllButton" onClick={() => this.handleSelectAll()}>
                                    Select All
                                </Button>
                                <span className="LselectAllQtyMessage" style={{ marginLeft: '16px' }}>
                                    {
                                        total > 0 ?
                                            `${total} Selected` :
                                            ''
                                    }
                                </span>
                            </Grid>
                            <Grid item container xs={8} justifyContent='flex-start' alignItems='center'>
                                <span className="LselectAllQtyMessage" style={{ marginLeft: '16px' }}>
                                    Choose what tiles will be displayed for the selected resident(s) on their eHubs.
                                </span>
                            </Grid>
                            <Grid container>
                                <Grid item container xs={12} justifyContent='flex-start'>
                                    {
                                        currentData.map((item) => {
                                            return (
                                                <Grid item container className="Lcategory_box_wrapper" >
                                                    <Grid item container justifyContent='center'
                                                        className={item.active ? 'Lfilters_category_box_selected' : 'Lfilters_category_box'}
                                                        onClick={() => this.handleCheckBoxClick(item)}
                                                    >
                                                        <Grid item container xs={12} justifyContent='flex-end'>
                                                            <Checkbox
                                                                checked={item.active}
                                                                onChange={(e) => this.handleCheckBoxClick(item)}
                                                                onClick={(e) => e.stopPropagation()}
                                                                icon={<CheckBoxOutlineBlank />}
                                                                checkedIcon={<CheckBox style={{ color: 'white' }} />}
                                                            />
                                                        </Grid>
                                                        <Grid item container xs={12} justifyContent='center'>
                                                            <img
                                                                src={item.iconUrl}
                                                                alt={`item_icon_${item.appName}`}
                                                                width='55px'
                                                                height='55px'
                                                                className={item.active ? "Lcategory_box_icon" : "logo-black Lcategory_box_icon"}
                                                            />
                                                        </Grid>

                                                        <Grid item container xs={12} justifyContent='center' className=" Lcategory_box_text">
                                                            {item.appName}
                                                        </Grid>
                                                    </Grid>
                                                </Grid>

                                            )
                                        })
                                    }
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </>
        )
    }
}

function mapStateToProps(state) {

    const homeAppsData = (state.homeAppsReducer && state.homeAppsReducer.homeAppsData) ? state.homeAppsReducer.homeAppsData : undefined;
    let residentData = (state.residentReducer && state.residentReducer.residentData) ? state.residentReducer.residentData : undefined;

    if (residentData && Array.isArray(residentData)) {
        residentData = residentData.map(item => {
            return {
                _id: item._id,
                name: `${item.firstName} ${item.lastName}`
            }
        })
    }

    const allresidentsObj = {
        _id: '000',
        name: 'All residents',
    }

    if (residentData) {
        residentData = [allresidentsObj, ...residentData];
    }

    return {
        homeAppsType: (state.homeAppsReducer && state.homeAppsReducer.type) ? state.homeAppsReducer.type : "",
        homeAppsData: homeAppsData,
        residentData: residentData,
    };
}


export default connect(mapStateToProps, { GetHomeApps, getResidentsByCommunity, UpdateHomeAppByCommunity })(reduxForm({
    form: 'ManagementTile',
    enableReinitialize: true
})(ManagementTile));